import { AWTriggers, AWTypes, SessionStatus } from 'enums';
import _ from 'lodash';
import Logger from '../logger';
import { API_V1 } from './APIs/APIv1';
import { Score } from '../features/augmented-writing/augmented-writing.types';

export const createUserBehavior = async (
  session: number,
  sessionStatus: SessionStatus,
  scores: Score,
  overall: number,
  domain?: string,
  wordCount?: number,
  awTrigger?: AWTriggers
) => {
  try {
    const scoresValue = {
      jointPosAchieve: scores.jointPosAchieve,
      jointPosAffil: scores.jointPosAffil,
      jointPosPower: scores.jointPosPower,
      authenticity: scores.authenticity,
      regFocus: scores.regFocus,
      diversity: scores.diversity,
      overall,
    };
    const res = await API_V1.post('/user-tracking/behavior', {
      session,
      sessionStatus,
      scoresValue,
      wordCount,
      domain,
      awTrigger,
    });
    return res.data;
  } catch (e) {
    Logger.trace('Error while creating user behavior ');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};

export const getLastSession = async () => {
  try {
    const res = await API_V1.get('/user-tracking/behavior/last-session');
    return res.data;
  } catch (e) {
    Logger.trace('Error while getting user behavior last session');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};

// External endpoint - uses apiKey instead of token
export const createUserBehaviorExternal = async (
  apiKey: string,
  session: number,
  sessionStatus: SessionStatus,
  scores: Score,
  overall: number,
  wordCount?: number,
  awTrigger?: AWTriggers
) => {
  try {
    const scoresValue = {
      jointPosAchieve: scores.jointPosAchieve,
      jointPosAffil: scores.jointPosAffil,
      jointPosPower: scores.jointPosPower,
      authenticity: scores.authenticity,
      regFocus: scores.regFocus,
      diversity: scores.diversity,
      overall,
    };
    const res = await API_V1.post(
      '/api/user-tracking/behavior',
      {
        session,
        sessionStatus,
        scoresValue,
        domain: AWTypes.CUSTOMER,
        wordCount,
        awTrigger,
      },
      {
        headers: {
          'x-api-key': apiKey,
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',
        },
      }
    );
    return res.data;
  } catch (e) {
    Logger.trace('Error while creating user behavior ');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};

// External endpoint - uses apiKey instead of token
export const getLastSessionExternal = async (apiKey: string) => {
  try {
    const res = await API_V1.get('/api/user-tracking/behavior/last-session', {
      headers: {
        'x-api-key': apiKey,
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      },
    });
    return res.data;
  } catch (e) {
    Logger.trace('Error while getting user behavior last session');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};
